/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";

// @ts-ignore: Vuetify styles module types are not found in this environment
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import { en, he } from "vuetify/locale";

export default createVuetify({
  locale: {
    locale: "en",
    fallback: "en",
    messages: { en, he },
    rtl: { he: true },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#202750",
          secondary: "#009688",
          accent: "#cddc39",
          error: "#f44336",
          warning: "#ffc107",
          info: "#607d8b",
          success: "#00bcd4",
          // primary: "#1867C0",
          // secondary: "#5CBBF6",
        },
      },
    },
  },
});
